import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				overflow: "hidden",
				padding: "10px 16px"
			},
			rootTabs: {
				height: 30,
				minHeight: 30,
				padding: "0px 10px",
				"& div.MuiTabs-scroller": {
					"& .MuiTabs-flexContainer": {
						alignItems: "flex-end"
					}
				}
			},
			rootAppBar: {
				background: theme.palette.common.white,
				boxShadow: "none !important"
			},
			rootTab: {
				background: "#D0D8E7",
				textTransform: "inherit",
				fontWeight: 500,
				minWidth: 75,
				minHeight: 24,
				height: 24,
				color: "white",
				boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.18)",
				borderRadius: "0px 8px 0px 0px"
			},
			selected: {
				fontWeight: 500,
				minHeight: 30,
				padding: "0px 17px",
				borderRadius: "8px 8px 0px 0px"
			}
		}),
	{
		name: "MenuLoyalty",
		index: 1
	}
);

export default useStyles;
